import React, { useEffect, useState } from 'react'
import styles from './animated_digit.module.scss'

interface Props {
    value: string
}

export default function AnimatedDigit({ value }: Props) {
    const [animating, setAnimating] = useState(false);
    const [animationDirection, setAnimationDirection] = useState('up');
    const [internalValue, setInternalValue] = useState(value);

    useEffect(() => {
        setAnimationDirection(value > internalValue ? 'up' : 'down');
        setAnimating(true);

        setTimeout(() => {
            setInternalValue(value);
            setAnimating(false)
        }, 250)
    }, [value])

    return (
        <div
            className={`${styles.digit} ${animating ? styles[`animate_${animationDirection}`] : ''}`}
            lang={'en'}
        >
            {internalValue}
        </div>
    )
}
